import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/bulk`;

export const ROUTE: RouteDefinition = `${baseRoute}/bulk`;

export const URL = (): RouteDefinition => `${baseRoute}/bulk`;
